import { configureStore } from '@reduxjs/toolkit';
import languageReducer from '../store/LanguageSlice';

export const store = configureStore({
  reducer: {
    language: languageReducer,
  },
});